module.exports = __webpack_public_path__ + "img/1440.de38b7ac.jpg";